/**
 * The Structure screens number modules and lessons themselves, so a stored
 * title that starts with its own "Module 1:" / "Lesson 2 -" label is shown
 * without it. Same rule the backend now applies when it generates titles; this
 * only matters for programs generated before that.
 */
export const displayStructureTitle = (title: string): string =>
  (title || '').replace(/^\s*(module|lesson)\s+\d+\s*[:.\-–—]\s*/i, '') || title;
